import { SalaryRestrictionStatus } from "@tymbe/legislatives/SalaryRestrictionStatus";

export const salaryRestrictionStatusNameMap: Record<SalaryRestrictionStatus, string> = {
  [SalaryRestrictionStatus.MinimalniNezabavitelnaCastka]: 'Minimalní nezabavitelná částka',
  [SalaryRestrictionStatus.Zablokovano]: 'Zablokováno',
}
